import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const VehicleFleet = () => {
  const settings = {
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000, 
    slidesToShow: 3, 
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2, 
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1, 
        },
      },
    ],
  };

  return (
    <div className='container'>

<div className="section-full p-t150 p-b120 site-bg-white twm-blog-section-wrap wow fadeInDown pb-0" data-wow-offset="100" data-wow-delay="0.2">
      <div className="container-fluid ">
        {/* Title */}
        <div className="section-head center">
          <div className="twm-sm-title left">Choose your Fleets</div>
          <h2 className="twm-large-title site-text-dark">Our Vehicle Fleet</h2>
        </div>

        {/* Carousel */}
        <div className="section-content container">
          <Slider {...settings} className="twm-vehicle-fleet-carousel m-b30">
            {/* Vehicle 1 */}
            <div className="item p-1">
              <div className="twm-vehicle-fleet-bx">
                <div className="twm-media">
                  <div className="twm-media-pic">
                    <img src="/images/our-fleet/4.jpg" alt="Jeep Renegade" />
                  </div>
                  <div className="twm-price-section">
                    {/* <div className="v-price">$800</div>
                    <div className="v-duration">/ Day</div> */}
                    <a href="our-fleet" className="v-detail"><em>Detail</em></a>
                  </div>
                </div>
                <div className="twm-vehicle-fleet-content">
                  <h3 className="twm-v-title"><a href="our-fleet">AURA</a></h3>
                  <ul className="twm-vehicle-facility">
                    <li><span><img src="images/icons/car-seat.png" alt="Seats" /></span>4 Seat</li>
                    {/* <li><span><img src="images/icons/bag.png" alt="Bags" /></span>4 Bags</li>
                    <li><span><img src="images/icons/car.png" alt="SUV" /></span>4 Suv</li> */}
                  </ul>
                  <ul className="twm-vehicle-fuel-type">
                    <li>Petrol</li>
                    <li><del>Diesel</del></li>
                    <li><del>Electric</del></li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Vehicle 2 */}
            <div className="item p-1">
              <div className="twm-vehicle-fleet-bx">
                <div className="twm-media">
                  <div className="twm-media-pic ">
                    <img src="/images/our-fleet/6.jpg" alt="Ferarri Enzo" />
                  </div>
                  <div className="twm-price-section">
                    {/* <div className="v-price">$700</div>
                    <div className="v-duration">/ Day</div> */}
                    <a href="our-fleet" className="v-detail"><em>Detail</em></a>
                  </div>
                </div>
                <div className="twm-vehicle-fleet-content">
                  <h3 className="twm-v-title"><a href="our-fleet">SCORPIO</a></h3>
                  <ul className="twm-vehicle-facility">
                    <li><span><img src="images/icons/car-seat.png" alt="Seats" /></span>8 Seat</li>
                    {/* <li><span><img src="images/icons/bag.png" alt="Bags" /></span>4 Bags</li>
                    <li><span><img src="images/icons/car.png" alt="SUV" /></span>4 Suv</li> */}
                  </ul>
                  <ul className="twm-vehicle-fuel-type">
                  <li>Diesel</li>
                    <li><del>Petrol</del></li>
                    <li><del>Electric</del></li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Vehicle 3 */}
            <div className="item p-1">
              <div className="twm-vehicle-fleet-bx">
                <div className="twm-media">
                  <div className="twm-media-pic">
                    <img src="/images/our-fleet/9.jpg" alt="Mini Cooper" />
                  </div>
                  <div className="twm-price-section">
                    {/* <div className="v-price">$900</div>
                    <div className="v-duration">/ Day</div> */}
                    <a href="our-fleet" className="v-detail"><em>Detail</em></a>
                  </div>
                </div>
                <div className="twm-vehicle-fleet-content">
                  <h3 className="twm-v-title"><a href="our-fleet">Kia Carens</a></h3>
                  <ul className="twm-vehicle-facility">
                    <li><span><img src="images/icons/car-seat.png" alt="Seats" /></span>6 Seat</li>
                    {/* <li><span><img src="images/icons/bag.png" alt="Bags" /></span>4 Bags</li>
                    <li><span><img src="images/icons/car.png" alt="SUV" /></span>4 Suv</li> */}
                  </ul>
                  <ul className="twm-vehicle-fuel-type">
                  <li>Diesel</li>
                    <li><del>Petrol</del></li>
                    <li><del>Electric</del></li>
                  </ul>
                </div>
              </div>
            </div>

            
          </Slider>
        </div>
      </div>
    </div>

    </div>
  );
};

export default VehicleFleet;
